import $i18n from 'panda-i18n';
import React from 'react';
import { vToLabel } from '@/utils/vToLabel';
import { OUT_OPERATE_TYPE, OUT_OPERATE_DETAIL_TYPE } from './outbound';
import { formatDate, diffStyle, isArray } from '@/utils';
import { PACKING_TEXTURE, BUSINESS_TYPE, PACKING_TYPE } from './BaseDataConst';
import { Y_N } from './GoodsConst';
import { STOCK_QUALITY } from './inbound';

const ORDER_TIME = [
  {
    label: $i18n.get({ id: 'ArrivalTime.four_px', dm: '到货时间' }),
    value: 'arriveTime',
  },

  {
    label: $i18n.get({ id: 'ReviewTime.four_px', dm: '审核时间' }),
    value: 'auditTime',
  },

  {
    label: $i18n.get({ id: 'AppointmentTime.four_px', dm: '预约时间' }),
    value: 'reservationTime',
  },

  {
    label: $i18n.get({ id: 'UnloadingTime.four_px', dm: '卸货时间' }),
    value: 'unloadFinishTime',
  },

  {
    label: $i18n.get({ id: 'DeliveryTime.four_px', dm: '收货时间' }),
    value: 'receiveFinishTime',
  },

  {
    label: $i18n.get({ id: 'ShelvingTime.four_px', dm: '上架时间' }),
    value: 'putawayFinishTime',
  },

  {
    label: $i18n.get({ id: 'TargetShelvingTime.four_px', dm: '目标上架时间' }),
    value: 'expectPutawayDate',
  },

  {
    label: $i18n.get({ id: 'TitSubmissionTime', dm: '理货提交时间' }),
    value: 'tallySubmitTime',
  },

  {
    label: $i18n.get({ id: 'TitReviewTime', dm: '理货审核时间' }),
    value: 'tallyAuditingTime',
  },
];

// 订单状态 itaskStatus:
const ORDER_MODULE_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Reviewed.four_px', dm: '已审核' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'Reserved.four_px', dm: '已预约' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'Unloaded.four_px', dm: '已卸货' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'Received.four_px', dm: '已收货' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'PartialShelving.four_px', dm: '部分上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Shelved.four_px', dm: '已上架' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },
];

// 异常原因 abnormalCause:
const ABNORMAL_CAUSE = [
  {
    label: $i18n.get({ id: 'Understaffed.four_px', dm: '人手不足' }),
    value: 'WARE_1',
  },

  {
    label: $i18n.get({ id: 'WarehouseExplosionUnableToHandle.four_px', dm: '仓库爆仓，无法处理' }),
    value: 'WARE_2',
  },

  {
    label: $i18n.get({ id: 'Error.four_px', dm: '操作失误' }),
    value: 'WARE_3',
  },

  {
    label: $i18n.get({ id: 'TheDeliveryBarcodeBoxInformationIs_1025995139.four_px', dm: '到货条码箱唛信息不规范' }),
    value: 'CUST_1',
  },

  {
    label: $i18n.get({ id: 'TheArrivalIsNotStandardizedAnd_2304780415.four_px', dm: '到货不规范，清点耗时' }),
    value: 'CUST_2',
  },

  {
    label: $i18n.get({ id: 'ArrivalDifference.four_px', dm: '到货差异' }),
    value: 'CUST_3',
  },

  {
    label: $i18n.get({ id: 'DeliveredInBatches.four_px', dm: '分批到货' }),
    value: 'CUST_4',
  },

  {
    label: $i18n.get({ id: 'ReceiptExceptionNotReceivedActually.four_px', dm: '签收异常-实际未收到' }),
    value: 'CUST_5 ',
  },

  {
    label: $i18n.get({ id: 'TheWarehouseArrivedLateAndThe_1331536483.four_px', dm: '到仓时间较晚，仓库来不及操作' }),
    value: 'CUST_6',
  },

  {
    label: $i18n.get({ id: 'SystemException.four_px', dm: '系统异常' }),
    value: 'SYS_1',
  },

  {
    label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
    value: 'OTHER_1',
  },
];

// SLA状态 slaStatus:
const SLA_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'UnhandledExceptions.four_px', dm: '异常待处理' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'ContinueToWait.four_px', dm: '继续等待' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'ForcedCompletion.four_px', dm: '强制完成' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'CloseCompensation.four_px', dm: '关闭赔偿' }),
    value: 'C',
  },
];

// SLA类型
const SLA_TYPE = [
  {
    label: $i18n.get({ id: 'YCD.Exception.four_px', dm: '异常单' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'Compliant.four_px', dm: '符合单' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'DoNotParticipateInTheOrder.four_px', dm: '不参与单' }),
    value: 'N',
  },
];

// 交货方式 arrivalType：
const ARRAIVAL_TYPE = [
  {
    label: $i18n.get({ id: 'AirTransport.four_px', dm: '空运' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'Maritime.four_px', dm: '海运' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'Express.four_px', dm: '快递' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'HighwayTruck.four_px', dm: '公路卡车' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'RailwayTrain.four_px', dm: '铁路火车' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'SelfExtractingInTheDatabase.four_px', dm: '在库自提' }),
    value: 'I',
  },
];

// 承运方式 carrierType：
const CARRIER_TYPE = [
  {
    label: $i18n.get({ id: '4pxCarrier.four_px', dm: '4PX承运' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Spontaneous.four_px', dm: '自发' }),
    value: 'M',
  },
];

// 异常责任方
const CAUSE_BY = [
  {
    label: $i18n.get({ id: 'Warehouse.four_px', dm: '仓库' }),
    value: 'WARE',
  },

  {
    label: $i18n.get({ id: 'Customer.four_px', dm: '客户' }),
    value: 'CUST',
  },

  {
    label: $i18n.get({ id: 'System.four_px', dm: '系统' }),
    value: 'SYS',
  },

  {
    label: $i18n.get({ id: 'Other.four_px', dm: '其它' }),
    value: 'OTHER',
  },
];

// 责任方对应原因
const CAUSE_LIST = {
  WARE: [
    {
      label: $i18n.get({ id: 'Understaffed.four_px', dm: '人手不足' }),
      value: 'WARE_1',
    },

    {
      label: $i18n.get({ id: 'WarehouseExplosionUnableToHandle.four_px', dm: '仓库爆仓，无法处理' }),
      value: 'WARE_2',
    },

    {
      label: $i18n.get({ id: 'Error.four_px', dm: '操作失误' }),
      value: 'WARE_3',
    },
  ],

  CUST: [
    {
      label: $i18n.get({ id: 'TheDeliveryBarcodeBoxInformationIs_1025995139.four_px', dm: '到货条码箱唛信息不规范' }),
      value: 'CUST_1',
    },

    {
      label: $i18n.get({ id: 'TheArrivalIsNotStandardizedAnd_2304780415.four_px', dm: '到货不规范，清点耗时' }),
      value: 'CUST_2',
    },

    {
      label: $i18n.get({ id: 'ArrivalDifference.four_px', dm: '到货差异' }),
      value: 'CUST_3',
    },

    {
      label: $i18n.get({ id: 'DeliveredInBatches.four_px', dm: '分批到货' }),
      value: 'CUST_4',
    },

    {
      label: $i18n.get({ id: 'ReceiptExceptionNotReceivedActually.four_px', dm: '签收异常-实际未收到' }),
      value: 'CUST_5 ',
    },

    {
      label: $i18n.get({ id: 'TheWarehouseArrivedLateAndThe_1331536483.four_px', dm: '到仓时间较晚，仓库来不及操作' }),
      value: 'CUST_6',
    },
  ],

  SYS: [
    {
      label: $i18n.get({ id: 'SystemException.four_px', dm: '系统异常' }),
      value: 'SYS_1',
    },
  ],

  OTHER: [
    {
      label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
      value: 'OTHER_1',
    },
  ],
};

// 是否收货
const IS_RECEIVE = [
  {
    label: $i18n.get({ id: 'Received.four_px', dm: '已收货' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'Unreceived.four_px', dm: '未收货' }),
    value: 'N',
  },
];

// 是否卸货
const IS_UNLOAD = [
  {
    label: $i18n.get({ id: 'Unloaded.four_px', dm: '已卸货' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'Undischarged', dm: '未卸货' }),
    value: 'N',
  },
];

// 是否新品
const IS_NEW_ITEM = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: 'N',
  },
];

// 是否已完结批次
const IS_CLOSE_BATCH = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: 'N',
  },
];

// 入库订单详情表格
const INBOUND_DETAIL_TABLE = {
  InboundDetail: [
    {
      title: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
      dataIndex: 'skuCode',
      lock: 'left',
      width: 180,
      cell: (value, index, record) => {
        return (
          <>
            <a target="_blank" href={`/goods/message/stockmessagedetail/${record.skuId}`} rel="noreferrer">
              {value}
            </a>
          </>
        );
      },
    },

    {
      title: $i18n.get({ id: 'BoxNo.four_px', dm: '箱序号' }),
      dataIndex: 'boxNo',
      width: 100,
    },

    {
      title: $i18n.get({ id: 'BoxBarCode.four_px', dm: '箱条码' }),
      dataIndex: 'boxBarcode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'CustomerBoxBarCode.four_px', dm: '客户箱条码' }),
      dataIndex: 'customBoxBarcode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'cargoType.four_px', dm: '货型' }),
      dataIndex: 'cargoType',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'SkuName.four_px', dm: 'SKU名称' }),
      dataIndex: 'skuName',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'NewProduct.four_px', dm: '是否新品' }),
      dataIndex: 'isFirstStorageOms',
      width: 150,
      cell: (value: string) => {
        return vToLabel(IS_NEW_ITEM, value);
      },
    },

    {
      title: (
        <div>
          <span>{$i18n.get({ id: 'SkuSingleWeight.four_px', dm: 'SKU单重' })}</span>
          <br />
          <span>
            {$i18n.get({
              id: 'Long.four_px',
              dm: '长',
            })}
            ({$i18n.get({ id: 'Diameter.four_px', dm: '直径' })})×
            {$i18n.get({
              id: 'Wide.four_px',
              dm: '宽',
            })}
            ×{$i18n.get({ id: 'High.four_px', dm: '高' })}
          </span>
        </div>
      ),

      dataIndex: 'skuGroup',
      width: 240,
      cell: (value, index, record) => {
        return (
          <>
            <span>{record.actualWeight && `${record.actualWeight}(kg)`}</span>
            <br />
            <span>{record.skuGroup}</span>
          </>
        );
      },
    },

    {
      title: 'SKU ID',
      dataIndex: 'skuId',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'PlatformThirdPartyEncoding.four_px', dm: '平台（第三方）编码' }),
      dataIndex: 'productCodes',
      width: 180,
      cell: (value) => {
        if (!(value && typeof (value === 'object') && value.constructor === Array)) return value;
        return (
          <>
            {value?.map((e) => {
              return (
                <span>
                  {e}
                  <br />
                </span>
              );
            })}
          </>
        );
      },
    },

    {
      title: $i18n.get({ id: 'ArrivalBatch.four_px', dm: '到货批次' }),
      dataIndex: 'arrivalBatch',
      width: 180,
    },

    {
      title: $i18n.get({ id: 'ReceiptOrNot.four_px', dm: '是否收货' }),
      dataIndex: 'isReceive',
      cell: (value: string) => {
        return vToLabel(IS_RECEIVE, value);
      },
      width: 150,
    },

    {
      title: $i18n.get({ id: 'BatchNumber.four_px', dm: '批次号' }),
      dataIndex: 'batchNo',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'ForecastQuantity.four_px', dm: '预报数量' }),
      dataIndex: 'planQty',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'ReceivedQuantity.four_px', dm: '收货数量' }),
      dataIndex: 'actualReceiveQty',
      key: 'actualReceiveQty',
      width: 150,
      cell: (value: string, index: number, record) => (
        <span style={diffStyle(record.actualReceiveQty, record.actualPutawayQty)}>{value}</span>
      ),
    },

    {
      title: $i18n.get({ id: 'SJSL.ShelvingQuantity.four_px', dm: '上架数量' }),
      dataIndex: 'actualPutawayQty',
      width: 150,
      cell: (value: string, index: number, record) => (
        <span style={diffStyle(record.actualReceiveQty, record.actualPutawayQty)}>{value}</span>
      ),
    },

    {
      title: $i18n.get({ id: 'TotalWeightOfReceivedSku.four_px', dm: '收货SKU总重' }),
      dataIndex: 'actualTotalWeight',
      width: 240,
    },
  ],

  ItaskBoxSummary: [
    {
      title: $i18n.get({ id: 'BoxNo.four_px', dm: '箱序号' }),
      dataIndex: 'boxNo',
      lock: 'left',
    },

    {
      title: $i18n.get({ id: 'BoxBarCode.four_px', dm: '箱条码' }),
      dataIndex: 'boxBarcode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'CustomerBoxBarCode.four_px', dm: '客户箱条码' }),
      dataIndex: 'customBoxBarcode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'ArrivalBatch.four_px', dm: '到货批次' }),
      dataIndex: 'arrivalBatch',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'WhetherToUnload', dm: '是否卸货' }),
      dataIndex: 'unloadStatus',
      width: 150,
      cell: (value: string) => {
        return vToLabel(IS_UNLOAD, value);
      },
    },

    {
      title: $i18n.get({ id: 'ReceiptOrNot.four_px', dm: '是否收货' }),
      dataIndex: 'isReceive',
      width: 150,
      cell: (value: string) => {
        return vToLabel(IS_RECEIVE, value);
      },
    },

    {
      title: $i18n.get({ id: 'BatchNumber.four_px', dm: '批次号' }),
      dataIndex: 'batchNo',
      width: 150,
    },

    // {
    //   title: $i18n.get({ id: 'CustomerBoxBarCode.four_px', dm: '客户箱条码' }),
    //   dataIndex: 'customBoxBarcode',
    //   width: 180,
    // },
    {
      title: $i18n.get({ id: 'ExternalBoxBarcode.four_px', dm: '外部箱条码' }),
      dataIndex: 'externalBoxBarcode',
      width: 180,
    },

    {
      title: $i18n.get({ id: 'SkuType.four_px', dm: 'SKU种类' }),
      dataIndex: 'skuKind',
    },

    {
      title: $i18n.get({ id: 'TotalSkusForecast.four_px', dm: '预报SKU总数' }),
      dataIndex: 'totalPlanQty',
      width: 180,
    },

    {
      title: $i18n.get({ id: 'TotalSkusReceived.four_px', dm: '实收SKU总数' }),
      dataIndex: 'totalReceiveQty',
      width: 180,
    },

    {
      title: $i18n.get({ id: 'SkuDifferences.four_px', dm: 'SKU差异数' }),
      dataIndex: 'diffSkuQty',
      width: 180,
    },

    {
      title: $i18n.get({ id: 'TotalNumberOfSkusOnShelves.four_px', dm: '上架SKU总数' }),
      dataIndex: 'totalPutawayQty',
      width: 240,
    },

    {
      title: `${$i18n.get({ id: 'TotalWeightOfReceivedSku.four_px', dm: '收货SKU总重' })}(KG)`,
      dataIndex: 'totalReceiveWeight',
      width: 240,
    },
  ],

  BatchDetail: [
    {
      title: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
      dataIndex: 'skuCode',
      lock: 'left',
      width: 150,
    },

    {
      title: 'SKU ID',
      dataIndex: 'skuId',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'PlatformThirdPartyEncoding.four_px', dm: '平台（第三方）编码' }),
      dataIndex: 'productCodes',
      width: 150,
      cell: (value) => {
        if (!(value && typeof (value === 'object') && value.constructor === Array)) return value;
        return (
          <>
            {value?.map((e) => {
              return (
                <span>
                  {e}
                  <br />
                </span>
              );
            })}
          </>
        );
      },
    },

    {
      title: $i18n.get({ id: 'ReceiptBatch.four_px', dm: '收货批次' }),
      dataIndex: 'batchNo',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'BatchTargetShelfTime.sjcNH', dm: '批次目标上架时间' }),
      dataIndex: 'expectBatchPutawayTime',
      width: 180,
      cell: (value: string) => formatDate(value),
    },

    {
      title: $i18n.get({ id: 'Disabled.four_px', dm: '是否关闭' }),
      dataIndex: 'isFinish',
      width: 150,
      cell: (value: string) => vToLabel(IS_CLOSE_BATCH, value),
    },

    {
      title: $i18n.get({ id: 'PCKSSJ.StartTime.four_px', dm: '批次开始时间' }),
      dataIndex: 'starTime',
      width: 150,
      cell: (value: number) => formatDate(value),
    },

    {
      title: $i18n.get({ id: 'PCJSSJ.EndTime.four_px', dm: '批次结束时间' }),
      dataIndex: 'endTime',
      width: 150,
      cell: (value: number) => formatDate(value),
    },

    {
      title: $i18n.get({ id: 'ForecastQuantity.four_px', dm: '预报数量' }),
      dataIndex: 'planQty',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'ReceivedQuantity.four_px', dm: '收货数量' }),
      dataIndex: 'actualReceiveQty',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'NumberOfDifferences.four_px', dm: '差异数量' }),
      dataIndex: 'diffQty',
      width: 150,
    },
  ],

  BatchEFDetail: [
    {
      title: $i18n.get({ id: 'BoxNo.four_px', dm: '箱序号' }),
      dataIndex: 'boxNo',
      lock: 'left',
    },

    {
      title: $i18n.get({ id: 'BoxBarCode.four_px', dm: '箱条码' }),
      dataIndex: 'boxBarcode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
      dataIndex: 'skuCode',
      width: 150,
    },

    {
      title: 'SKU ID',
      dataIndex: 'skuId',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'PlatformThirdPartyEncoding.four_px', dm: '平台（第三方）编码' }),
      dataIndex: 'productCodes',
      width: 150,
      cell: (value) => {
        if (!(value && typeof (value === 'object') && value.constructor === Array)) return value;
        return (
          <>
            {value?.map((e) => {
              return (
                <span>
                  {e}
                  <br />
                </span>
              );
            })}
          </>
        );
      },
    },

    {
      title: $i18n.get({ id: 'ReceiptBatch.four_px', dm: '收货批次' }),
      dataIndex: 'batchNo',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'Disabled.four_px', dm: '是否关闭' }),
      dataIndex: 'isFinish',
      width: 150,
      cell: (value: string) => vToLabel(IS_CLOSE_BATCH, value),
    },

    {
      title: $i18n.get({ id: 'PCKSSJ.StartTime.four_px', dm: '批次开始时间' }),
      dataIndex: 'starTime',
      width: 150,
      cell: (value: number) => formatDate(value),
    },

    {
      title: $i18n.get({ id: 'PCJSSJ.EndTime.four_px', dm: '批次结束时间' }),
      dataIndex: 'endTime',
      width: 150,
      cell: (value: number) => formatDate(value),
    },

    {
      title: $i18n.get({ id: 'ForecastQuantity.four_px', dm: '预报数量' }),
      dataIndex: 'planQty',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'ReceivedQuantity.four_px', dm: '收货数量' }),
      dataIndex: 'actualReceiveQty',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'NumberOfDifferences.four_px', dm: '差异数量' }),
      dataIndex: 'diffQty',
      width: 150,
    },
  ],

  OperationLog: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      cell: (value: string, index: number) => {
        return index + 1;
      },
      lock: 'left',
      width: '80px',
    },

    {
      title: $i18n.get({ id: 'JobId.four_px', dm: '作业单号' }),
      dataIndex: 'jobNo',
    },

    {
      title: $i18n.get({ id: 'OperationType.four_px', dm: '操作类型' }),
      dataIndex: 'operationNode',
      cell: (value: string) => {
        return vToLabel(OPERATE_TYPE, value);
      },
    },

    {
      title: $i18n.get({ id: 'Description.four_px', dm: '操作内容' }),
      dataIndex: 'operationCode',
      cell: (value: string, index, record) => {
        if (record.operationNode === 'UAW' && value) {
          const codeArr = value.split(',');
          const str =
            codeArr?.length === 2
              ? `${$i18n.get({ id: 'By', dm: '由' })} ${vToLabel(ACTUAL_ARRIVAL_METHOD, codeArr[0])}${$i18n.get({
                  id: 'Read',
                  dm: '改为',
                })} ${vToLabel(ACTUAL_ARRIVAL_METHOD, codeArr[1])}`
              : `${$i18n.get({ id: 'ReadFrom', dm: '由 - 改为' })} ${vToLabel(ACTUAL_ARRIVAL_METHOD, codeArr[0])}`;
          return str;
        }
        return vToLabel(OPERATE_CONTENT, value);
      },
    },

    {
      title: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
      dataIndex: 'empCode',
    },

    {
      title: $i18n.get({ id: 'OperationTime.four_px', dm: '操作时间' }),
      dataIndex: 'createTime',
      cell: (value: number) => formatDate(value),
    },

    {
      title: $i18n.get({ id: 'Remarks', dm: '备注' }),
      dataIndex: 'remark',
    },
  ],

  ItaskTrackDetail: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      cell: (value: string, index: number) => {
        return index + 1;
      },
      lock: 'left',
    },

    {
      title: $i18n.get({ id: 'OperationType.four_px', dm: '操作类型' }),
      dataIndex: 'operationType',
      cell: (value: string) => {
        return vToLabel(IN_OPERATE_TYPE, value);
      },
    },

    {
      title: $i18n.get({ id: 'Description.four_px', dm: '操作内容' }),
      dataIndex: 'operationContent',
      cell: (value: string) => {
        return vToLabel(IN_OPERATE_CON, value);
      },
    },

    {
      title: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
      dataIndex: 'empCode',
    },

    {
      title: $i18n.get({ id: 'OperationTime.four_px', dm: '操作时间' }),
      dataIndex: 'operationTime',
      cell: (value: number) => formatDate(value),
    },
  ],
};

// 入库操作日志
// 操作内容
const IN_OPERATE_CON = [
  {
    label: $i18n.get({ id: 'SubmitAnOrder.four_px', dm: '提交订单' }),
    value: 'OS',
  },

  {
    label: $i18n.get({ id: 'SLACL.SlaProcessing.four_px', dm: 'SLA处理' }),
    value: 'SD',
  },

  {
    label: $i18n.get({ id: 'PcUpdateArrivalTime.four_px', dm: 'PC更新到货时间' }),
    value: 'UA',
  },

  {
    label: $i18n.get({ id: 'AppointmentCompleted.four_px', dm: '预约完成' }),
    value: 'RF',
  },

  {
    label: $i18n.get({ id: 'ContinueToWait.four_px', dm: '继续等待' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'ForcedEnd.four_px', dm: '强制完结' }),
    value: 'F',
  },

  {
    label: $i18n.get({ id: 'CloseAndCompensate.four_px', dm: '关闭并赔偿' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'OrderCancellation.four_px', dm: '订单取消' }),
    value: 'OC',
  },

  {
    label: $i18n.get({ id: 'CancelAnAppointment.four_px', dm: '预约取消' }),
    value: 'RC',
  },

  {
    label: $i18n.get({ id: 'CompletedOrder.four_px', dm: '完结订单' }),
    value: 'CI',
  },

  {
    label: $i18n.get({ id: 'CompletedBatch.four_px', dm: '完结批次' }),
    value: 'FB',
  },

  {
    label: $i18n.get({ id: 'SynchronizingShelfInformation', dm: '同步上架信息' }),
    value: 'SPI',
  },
];

// 操作类型
const IN_OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'OrderReview.four_px', dm: '订单审核' }),
    value: 'OA',
  },

  {
    label: $i18n.get({ id: 'Appointment.four_px', dm: '预约' }),
    value: 'RP',
  },

  {
    label: $i18n.get({ id: 'RegistrationArrivalTime.four_px', dm: '登记到货时间' }),
    value: 'AR',
  },

  {
    label: $i18n.get({ id: 'SlaProcessing.four_px', dm: 'SLA-处理' }),
    value: 'SD',
  },

  {
    label: $i18n.get({ id: 'OrderOperations.four_px', dm: '订单操作' }),
    value: 'IO',
  },
];

// 入库订单表单搜索区域的checkBox数据
const IN_ORDER_CHECKBOX_TYPE = [
  {
    label: $i18n.get({ id: 'ThereIsADifferenceInQuantity_202992654', dm: '数量有差异' }),
    value: 'putawayQtyVaries',
  },

  {
    label: $i18n.get({ id: 'ThereIsADifferenceInReceipt_54088743', dm: '收货有异常' }),
    value: 'receiveQtyVaries',
  },
];

// 出库订单 --- 操作日志 --- 操作内容
const OUT_OPERATE_MSG_TYPE = [
  {
    label: $i18n.get({ id: 'Reviewed.four_px', dm: '已审核' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'PendingOrder.four_px', dm: '待汇单' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'OutboundException.four_px', dm: '出库异常' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'Matched.four_px', dm: '已匹配' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'Cancel.four_px', dm: '取消' }),
    value: 'X',
  },

  {
    label: $i18n.get({ id: 'RemittanceInProgress.four_px', dm: '汇单中' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'OrdersReceived.four_px', dm: '已汇单' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'JHZ.Picking.four_px', dm: '拣货中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'PickedUp.four_px', dm: '已拣货' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'SortingInProgress.four_px', dm: '分拣中' }),
    value: 'Q',
  },

  {
    label: $i18n.get({ id: 'Sorted.four_px', dm: '已分拣' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'Packaging.four_px', dm: '打包中' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Packaged.four_px', dm: '已打包' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: 'PartiallyShipped', dm: '部分出库' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'OutOfStock.four_px', dm: '已出库' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'InCollection', dm: '集货中' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'Collated.1iJ1Z', dm: '已集货' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'InOnePoint', dm: '一分中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'OnePoint', dm: '已一分' }),
    value: 'H',
  },
];

// 出库订单详情表格
const OUTBOUND_DETAIL_TABLE = {
  sku: [
    {
      title: 'NO.',
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index, record) => index + 1,
      lock: true,
      width: 100,
    },

    {
      title: $i18n.get({ id: 'ProductCode.four_px', dm: '商品编码' }),
      dataIndex: 'productCode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
      dataIndex: 'skuCode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'SkuName.four_px', dm: 'SKU名称' }),
      dataIndex: 'skuName',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'SkuQuantity.four_px', dm: 'SKU数量' }),
      dataIndex: 'qty',
      width: 200,
    },

    {
      title: `${$i18n.get({ id: 'SingleWeight.four_px', dm: '单重' })}(KG)`,
      dataIndex: 'weight',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'SingleSizeCM', dm: '单尺寸(CM)' }),
      dataIndex: '',
      width: 200,
      cell: (value: string, index: number, record) => {
        return (
          <>
            {record?.length || ''} * {record?.width || ''} * {record?.height || ''}
          </>
        );
      },
    },

    {
      title: $i18n.get({ id: 'BatchNumber.four_px', dm: '批次号' }),
      dataIndex: 'batchNo',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'InventoryQuality.four_px', dm: '库存质量' }),
      dataIndex: 'stockQuality',
      width: 200,
      cell: (value: string) => {
        return vToLabel(STOCK_QUALITY, value);
      },
    },

    {
      title: $i18n.get({ id: 'WhetherToBringYourOwnPackaging_628068444', dm: '是否自带包装' }),
      dataIndex: 'logisticsPackage',
      width: 200,
      cell: (value: string) => vToLabel(Y_N, value),
    },
    {
      title: $i18n.get({ id: 'SNManagement', dm: '是否SN管理' }),
      dataIndex: 'isSn',
      width: 200,
      cell: (value: string) => vToLabel(Y_N, value),
    },
  ],

  recommendPackage: [
    {
      title: $i18n.get({ id: 'RecommendPackingMaterialModel', dm: '推荐包材型号' }),
      dataIndex: 'packageNo',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'RecommendedPackingMaterialType', dm: '推荐包材类型' }),
      dataIndex: 'reCommendPackageType',
      width: 200,
      cell: (value: string) => {
        return vToLabel(PACKING_TYPE, value);
      },
    },

    {
      title: $i18n.get({ id: 'RecommendedPackingMaterialBusine_1929285098', dm: '推荐包材业务类型' }),
      dataIndex: 'reCommendPackageBizType',
      width: 200,
      cell: (value: string) => {
        if (!value) return '';
        return value
          .split(',')
          .map((code) => vToLabel(BUSINESS_TYPE, code.trim()) || code)
          .join(',');
      },
    },

    {
      title: $i18n.get({ id: 'RecommendedPackingMaterialLength_313551884', dm: '推荐包材长(cm)' }),
      dataIndex: 'recommendPackageLength',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'RecommendedPackingMaterialWidthC_646700654', dm: '推荐包材宽(cm)' }),
      dataIndex: 'recommendPackageWidth',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'RecommendedPackingMaterialHeight_1310064211', dm: '推荐包材高(cm)' }),
      dataIndex: 'recommendPackageHeight',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'RecommendedPackingMaterialWeight_125605104', dm: '推荐包材重量(kg)' }),
      dataIndex: 'recommendPackageWeight',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'RecommendedPackageLengthCm', dm: '推荐包裹长(cm)' }),
      dataIndex: 'recommendParcelLength',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'RecommendedPackageWidthCm', dm: '推荐包裹宽(cm)' }),
      dataIndex: 'recommendParcelWidth',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'RecommendedPackageHeightCm', dm: '推荐包裹高(cm)' }),
      dataIndex: 'recommendParcelHeight',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'RecommendedPackageWeightKg', dm: '推荐包裹重量(kg)' }),
      dataIndex: 'recommendParcelWeight',
      width: 200,
    },
  ],

  mulPackage: [
    {
      title: $i18n.get({ id: '31255237876649984.CNTM', dm: '包裹号' }),
      dataIndex: 'parcelNo',
      width: 240,
      lock: true,
    },

    {
      title: $i18n.get({ id: 'Subnumber', dm: '子单号' }),
      dataIndex: 'suborNo',
      width: 240,
    },

    {
      title: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
      dataIndex: 'skuCode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'ProductCode.four_px', dm: '商品编码' }),
      dataIndex: 'productCodes',
      width: 200,
      cell: (value) => {
        if (isArray(value)) {
          return (
            <>
              {value?.map((e) => {
                return (
                  <span>
                    {e}
                    <br />
                  </span>
                );
              })}
            </>
          );
        }
        return value;
      },
    },

    {
      title: $i18n.get({ id: 'Number.four_px', dm: '数量' }),
      dataIndex: 'qty',
      width: 100,
    },

    {
      title: $i18n.get({ id: 'PackagingCode', dm: '包装编码' }),
      dataIndex: 'packageNo',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'PackageName.four_px', dm: '包装名称' }),
      dataIndex: 'packageName',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'PackageSizeCM', dm: '包裹尺寸（CM）' }),
      dataIndex: '',
      width: 200,
      cell: (value: string, index: number, record) => {
        return (
          <>
            {record?.length || ''} * {record?.width || ''} * {record?.height || ''}
          </>
        );
      },
    },

    {
      title: $i18n.get({ id: 'WeightOfWrappedGoodsKG', dm: '包裹商品重量（KG）' }),
      dataIndex: 'skuTotalWeight',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'PackageDeliveryWeightKG', dm: '包裹发货重量（KG）' }),
      dataIndex: 'shippedWeight',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'WeightOfPackageMaterialKG', dm: '包材重量（KG）' }),
      dataIndex: 'packageWeight',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'SizeOfPackageMaterialCM', dm: '包材尺寸（CM）' }),
      dataIndex: '',
      width: 200,
      cell: (value: string, index: number, record) => {
        return (
          <>
            {record?.packageLength} * {record?.packageWidth} * {record?.packageHeight}
          </>
        );
      },
    },

    {
      title: $i18n.get({ id: 'PackageType.four_px', dm: '包装类型' }),
      dataIndex: 'packageType',
      width: 200,
      cell: (value: string) => vToLabel(PACKING_TEXTURE, value),
    },

    {
      title: $i18n.get({ id: 'PackagingMaterial.four_px', dm: '包装材质' }),
      dataIndex: 'packageMaterial',
      width: 200,
    },
    {
      title: $i18n.get({ id: 'put_away_txt_pallet_no', dm: '托盘号' }),
      dataIndex: 'palletId',
      width: 200,
    },
    {
      title: $i18n.get({ id: 'PalletSerialNumber', dm: '托盘序号' }),
      dataIndex: 'palletSerialNo',
      width: 200,
    },
  ],

  estimatedPalletInfo: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index, record) => index + 1,
      lock: true,
      width: 100,
    },

    {
      title: $i18n.get({ id: 'PalletBarcode', dm: '托盘条码' }),
      dataIndex: 'palletCode',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'ZLkg.WeightKg.four_px', dm: '重量(kg)' }),
      dataIndex: 'weight',
      width: 100,
    },

    {
      title: $i18n.get({ id: 'LengthWidthHeight.four_px', dm: '长*宽*高' }) + '(cm)',
      cell: (value, index, record) => {
        return (
          <>
            <span>
              {record?.length} * {record?.width} * {record?.height}
            </span>
          </>
        );
      },
      width: 200,
    },

    {
      title: $i18n.get({ id: 'Volume.four_px', dm: '体积' }) + '(cmb)',
      dataIndex: 'volume',
      width: 100,
    },
  ],

  actualPalletInfo: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index, record) => index + 1,
      lock: true,
      width: 80,
    },

    {
      title: $i18n.get({ id: 'put_away_txt_pallet_no', dm: '托盘号' }),
      dataIndex: 'palletCode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'PalletSize', dm: '托盘尺寸' }) + '(cm)',
      cell: (value, index, record) => {
        return (
          <>
            <span>
              {record?.palletLength} * {record?.palletWidth} * {record?.palletHeight}
            </span>
          </>
        );
      },
      width: 200,
    },

    {
      title: $i18n.get({ id: 'PalletWeight', dm: '托盘重量' }) + '(KG)',
      dataIndex: 'palletWeight',
      width: 100,
    },
    {
      title: $i18n.get({ id: 'DeliveryTime', dm: '发货时间' }),
      dataIndex: 'dispatchDateStr',
      width: 200,
      cell: (value: number) => formatDate(value),
    },
  ],

  mergeTransportationOrderInfo: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index, record) => index + 1,
      lock: true,
      width: 80,
    },

    {
      title: $i18n.get({ id: 'ConsolidatedTransportationOutbou_26905619', dm: '合并运输出库委托单' }),
      cell: (value, index, record) => {
        return record.toString();
      },
      width: 150,
    },
  ],

  pallet: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index, record) => index + 1,
      lock: true,
      width: 100,
    },

    {
      title: $i18n.get({ id: 'PalletBarcode', dm: '托盘条码' }),
      dataIndex: 'palletNo',
      width: 200,
    },

    {
      title: 'SKU',
      dataIndex: 'skuCode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'Number.four_px', dm: '数量' }),
      dataIndex: 'actualQty',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'ZLkg.WeightKg.four_px', dm: '重量(kg)' }),
      dataIndex: 'weight',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'LengthWidthHeight.four_px', dm: '长*宽*高 (cm)' }) + '(cm)',
      dataIndex: 'size',
      cell: (value, index, record) => {
        return (
          <>
            <span>
              {record?.length} * {record?.width} * {record?.height}
            </span>
          </>
        );
      },
      width: 200,
    },

    {
      title: $i18n.get({ id: 'Volume.four_px', dm: '体积(cmb)' }) + '(cmb)',
      dataIndex: 'volume',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'WeightLb', dm: '重量(lb)' }),
      dataIndex: 'weightLb',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'LengthWidthHeightInch_990178128', dm: '长*宽*高(inch)' }),
      dataIndex: 'inchSize',
      cell: (value, index, record) => {
        return (
          <>
            <span>
              {record?.lengthCh} * {record?.widthCh} * {record?.heightCh}
            </span>
          </>
        );
      },
      width: 200,
    },
  ],

  task: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index, record) => index + 1,
      lock: true,
      width: 200,
    },

    {
      title: $i18n.get({ id: 'JobId.four_px', dm: '作业单号' }),
      dataIndex: 'consignmentNo',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'OperationType.four_px', dm: '操作类型' }),
      dataIndex: 'operateType',
      cell: (value) => vToLabel(OUT_OPERATE_TYPE, value),
      width: 200,
    },

    {
      title: $i18n.get({ id: 'Description.four_px', dm: '操作内容' }),
      dataIndex: 'operateMsg',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
      dataIndex: 'operator',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'OperationTime.four_px', dm: '操作时间' }),
      dataIndex: 'operateTime',
      cell: (value) => formatDate(value),
      width: 200,
    },
  ],

  opa: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index, record) => index + 1,
      lock: true,
      width: 200,
    },

    {
      title: $i18n.get({ id: 'OperationType.four_px', dm: '操作类型' }),
      dataIndex: 'operateType',
      width: 200,
      cell: (value) => vToLabel(OUT_OPERATE_DETAIL_TYPE, value),
    },

    {
      title: $i18n.get({ id: 'Description.four_px', dm: '操作内容' }),
      dataIndex: 'operateMsg',
      width: 200,
      cell: (value: [], index: number, record: any) => {
        return Array.isArray(value)
          ? transferOperateMsg(value, index, record) + (record.msgExtend || '')
          : vToLabel(OUT_OPERATE_MSG_TYPE, value);
      },
    },

    {
      title: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
      dataIndex: 'operator',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'OperationTime.four_px', dm: '操作时间' }),
      dataIndex: 'operateTime',
      cell: (value) => formatDate(value),
      width: 200,
    },
  ],

  sninfo: [
    {
      title: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
      dataIndex: 'skuCode',
      width: 200,
    },
    {
      title: $i18n.get({ id: '31255237822124032.CNTM', dm: 'SN码' }),
      dataIndex: 'sn',
      width: 200,
    },
    {
      title: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
      dataIndex: 'operator',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'OperationTime.four_px', dm: '操作时间' }),
      dataIndex: 'createTime',
      cell: (value) => formatDate(value),
      width: 200,
    },
  ],
};
/**
 * 描述翻译
 * 后端返回["W","P"]格式
 * 1. 对类型code做国际化翻译
 * 2. 数组转字符串处理
 * @param value
 * @param index
 * @param record
 * @returns
 */
const transferOperateMsg = (value: [], index: number, record: any) => {
  return value
    ?.map((e: string, i: number) => {
      return i === value?.length - 1 ? vToLabel(OUT_OPERATE_MSG_TYPE, e) : `${vToLabel(OUT_OPERATE_MSG_TYPE, e)} ===>`;
    })
    ?.join('');
};

const BOUNCE_OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'ReturnAndReceive.four_px', dm: '退件收货' }),
    value: 'RECEIVE',
  },

  {
    label: $i18n.get({ id: 'ReturnUpperShelf.four_px', dm: '退件上架' }),
    value: 'PUTAWAY',
  },
];

const BOUNCE_OPERATE_CONTENT = [
  {
    label: $i18n.get({ id: 'ReceivingOperations.four_px', dm: '收货操作' }),
    value: 'RECEIVE_OPERATE',
  },

  {
    label: $i18n.get({ id: 'SHWC.Received.four_px', dm: '收货完成' }),
    value: 'RECEIVE_FINISH',
  },

  {
    label: $i18n.get({ id: 'ShelvingOperation.four_px', dm: '上架操作' }),
    value: 'PUTAWAY_OPERATE',
  },

  {
    label: $i18n.get({ id: 'ShelvingCompleted.four_px', dm: '上架完成' }),
    value: 'PUTAWAY_FINISH',
  },
];

// 退件订单详情表格
// 入库订单详情表格
const BOUNCE_DETAIL_TABLE = {
  InboundDetail: [
    {
      title: 'No.',
      dataIndex: 'NO',
      key: 'NO',
      cell: (v, i) => i + 1,
      width: 100,
      lock: 'left',
    },

    {
      title: 'SKU ID',
      dataIndex: 'skuId',
      key: 'skuId',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
      dataIndex: 'skuCode',
      key: 'skuCode',
      width: 200,
    },

    {
      title: $i18n.get({ id: 'SkuName.four_px', dm: 'SKU名称' }),
      dataIndex: 'skuName',
      key: 'skuName',
      width: 150,
    },

    {
      // title: 'SKU数量（正常）',
      title: `${$i18n.get({ id: 'SkuQuantity.four_px', dm: 'SKU数量' })}(${$i18n.get({
        id: 'Normal.four_px',
        dm: '正常',
      })})`,

      dataIndex: 'goodQty',
      key: 'goodQty',
      width: 200,
    },

    {
      // title: 'SKU数量（异常）',
      title: `${$i18n.get({ id: 'SkuQuantity.four_px', dm: 'SKU数量' })}(${$i18n.get({
        id: 'YC.Exception.four_px',
        dm: '异常',
      })})`,

      dataIndex: 'badQty',
      key: 'badQty',
      width: 200,
    },

    {
      title: `${$i18n.get({ id: 'SingleWeight.four_px', dm: '单重' })}(KG)`,
      dataIndex: 'weight',
      key: 'weight',
      width: 150,
    },
  ],

  ItaskTrackDetail: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index) => {
        return index + 1;
      },
      width: 100,
      lock: 'left',
    },

    {
      title: $i18n.get({ id: 'JobId.four_px', dm: '作业单号' }),
      dataIndex: 'jobNo',
      key: 'jobNo',
      width: 230,
    },

    {
      title: $i18n.get({ id: 'OperationType.four_px', dm: '操作类型' }),
      dataIndex: 'operationNode',
      key: 'operationNode',
      cell: (value) => {
        return vToLabel(OPERATE_TYPE, value);
      },
      width: 150,
    },

    {
      title: $i18n.get({ id: 'Description.four_px', dm: '操作内容' }),
      dataIndex: 'operationCode',
      key: 'operationCode',
      cell: (value) => {
        return vToLabel(OPERATE_CONTENT, value);
      },
      width: 200,
    },

    {
      title: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
      dataIndex: 'empCode',
      key: 'empCode',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'OperationTime.four_px', dm: '操作时间' }),
      dataIndex: 'createTime',
      key: 'createTime',
      cell: (value) => formatDate(value),
      width: 200,
    },
  ],

  rtaskLog: [
    {
      title: $i18n.get({ id: 'SerialNumber.four_px', dm: '序号' }),
      dataIndex: 'NO',
      key: 'NO',
      cell: (value, index) => {
        return index + 1;
      },
      width: 100,
      lock: 'left',
    },

    {
      title: $i18n.get({ id: 'JobId.four_px', dm: '作业单号' }),
      dataIndex: 'jobNo',
      key: 'jobNo',
      width: 230,
    },

    {
      title: $i18n.get({ id: 'OperationType.four_px', dm: '操作类型' }),
      dataIndex: 'operateType',
      key: 'operateType',
      cell: (value) => {
        return vToLabel(BOUNCE_OPERATE_TYPE, value);
      },
      width: 150,
    },

    {
      title: $i18n.get({ id: 'Description.four_px', dm: '操作内容' }),
      dataIndex: 'operateMsg',
      key: 'operateMsg',
      cell: (value) => {
        return vToLabel(BOUNCE_OPERATE_CONTENT, value);
      },
      width: 200,
    },

    {
      title: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
      dataIndex: 'operatorCode',
      key: 'operatorCode',
      width: 150,
    },

    {
      title: $i18n.get({ id: 'OperationTime.four_px', dm: '操作时间' }),
      dataIndex: 'operateTime',
      key: 'operateTime',
      cell: (value) => formatDate(value),
      width: 230,
    },
  ],
};

// 操作类型
const OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'Unloading.four_px', dm: '卸货' }),
    value: 'U',
  },

  {
    label: $i18n.get({ id: 'Receipt.four_px', dm: '收货' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'ModifyTheActualArrivalMethod', dm: '修改实际到货方式' }),
    value: 'UAW',
  },
];

// 操作内容
const OPERATE_CONTENT = [
  {
    label: $i18n.get({ id: 'UnloadingScanInboundOrderNoBox_967926409.four_px', dm: '卸货-扫描入库订单号箱唛号' }),
    value: 'U0001',
  },

  {
    label: $i18n.get({ id: 'UnloadingUnloadingSubmission.four_px', dm: '卸货-卸货提交' }),
    value: 'U0002',
  },

  {
    label: $i18n.get({ id: 'UnloadingExceptionHandling.four_px', dm: '卸货-异常处理' }),
    value: 'U0003',
  },

  {
    label: $i18n.get({ id: 'UnloadingForcedCompletion.four_px', dm: '卸货-强制完结' }),
    value: 'U0004',
  },

  {
    label: $i18n.get({ id: 'UnloadingAndChangingWarehouse', dm: '卸货改仓' }),
    value: 'U0008',
  },

  {
    label: $i18n.get({ id: 'ReceiptScanInboundOrderNoBox_2324256680.four_px', dm: '收货-扫描入库订单号箱唛号' }),
    value: 'R0001',
  },

  {
    label: $i18n.get({ id: 'ReceiptScanTheTurnoverBox.four_px', dm: '收货-扫周转箱' }),
    value: 'R0002',
  },

  {
    label: $i18n.get({ id: 'ReceiptScanTheSkuCode.four_px', dm: '收货-扫SKU编码' }),
    value: 'R0003',
  },

  {
    label: $i18n.get({ id: 'ReceiptSkuInspection.four_px', dm: '收货-SKU查验' }),
    value: 'R0004',
  },

  {
    label: $i18n.get({ id: 'ReceiptContainerReceiptSubmission.four_px', dm: '收货-容器收货提交' }),
    value: 'R0005',
  },

  {
    label: $i18n.get({ id: 'ReceiptSubmitReceiptByOrder.four_px', dm: '收货-按单收货提交' }),
    value: 'R0006',
  },

  {
    label: $i18n.get({ id: 'DeliveryForcedCompletion.four_px', dm: '收货-强制完结' }),
    value: 'R0007',
  },

  {
    label: $i18n.get({ id: 'ReceivingAndChangingWarehouse', dm: '收货改仓' }),
    value: 'R0008',
  },

  {
    label: $i18n.get({ id: 'ReceivingExceptionHandling', dm: '收货-异常处理' }),
    value: 'R0009',
  },

  {
    label: $i18n.get({ id: 'ReceiptTaleReportConfirmation', dm: '收货-理货报告确认' }),
    value: 'R0010',
  },

  {
    label: $i18n.get({ id: 'ReceivingToldReportRejected', dm: '收货-理货报告驳回' }),
    value: 'R0011',
  },

  {
    label: $i18n.get({ id: 'ReceivingToldReportSubmission', dm: '收货-理货报告提交' }),
    value: 'R0012',
  },

  {
    label: $i18n.get({ id: 'EmptyReceipt', dm: '清空收货' }),
    value: 'R0014',
  },
  {
    label: $i18n.get({ id: 'CompleteReceipt', dm: '完成收货' }),
    value: 'R0015',
  },

  {
    label: $i18n.get({ id: 'ModifyReceivingQuantity', dm: '修改收货数量' }),
    value: 'R0016',
  },
  {
    label: $i18n.get({ id: 'ShelvingScanningContainer.four_px', dm: '上架-扫描容器' }),
    value: 'P0001',
  },

  {
    label: $i18n.get({ id: 'ShelvingSubmitContainerShelving.four_px', dm: '上架-提交容器上架' }),
    value: 'P0002',
  },

  {
    label: $i18n.get({ id: 'ShelvingScanInboundOrderNoBox_2360481104.four_px', dm: '上架-扫描入库订单号箱唛号' }),
    value: 'P0003',
  },

  {
    label: $i18n.get({ id: 'ShelvingScanSkuCode.four_px', dm: '上架-扫描SKU编码' }),
    value: 'P0004',
  },

  {
    label: $i18n.get({ id: 'ShelvingSubmitSkuShelving.four_px', dm: '上架-提交SKU上架' }),
    value: 'P0005',
  },

  {
    label: $i18n.get({ id: 'ShelvingExceptionHandling.four_px', dm: '上架-异常处理' }),
    value: 'P0006',
  },

  {
    label: $i18n.get({ id: 'ShelvingForcedCompletion.four_px', dm: '上架-强制完结' }),
    value: 'P0007',
  },

  {
    label: $i18n.get({ id: 'ShelfChangeWarehouse', dm: '上架改仓' }),
    value: 'P0008',
  },

  {
    label: $i18n.get({ id: 'ShelfVAS', dm: '上架-VAS' }),
    value: 'P0009',
  },

  {
    label: $i18n.get({ id: 'ReceivingExceptionHandling', dm: '收货-异常处理' }),
    value: 'P00010',
  },

  {
    label: $i18n.get({ id: 'CompulsoryCompletionOfUnloading', dm: '卸货强制完结' }),
    value: 'U0005',
  },
];

/**
 * 退件订单订单类别
 */
const BOUNCE_ORDER = [
  {
    label: $i18n.get({ id: 'ReturnOrderNo.four_px', dm: '退件订单号' }),
    value: 'rtaskNoList',
  },

  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNoList',
  },

  {
    label: $i18n.get({ id: 'ServiceProviderId.four_px', dm: '服务商单号' }),
    value: 'shippingNoList',
  },

  // {
  //   label: $i18n.get({ id: 'GrsOrderNo.four_px', dm: 'GRS订单号' }),
  //   value: '',
  // },
];

/**
 * 退件订单时间类别
 */
const BOUNCE_ORDER_TIME = [
  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },

  {
    label: $i18n.get({ id: 'PresortingTime', dm: '预分拣时间' }),
    value: 'preSortOperateTime',
  },

  {
    label: $i18n.get({ id: 'DeliveryCompletionTime.four_px', dm: '收货完成时间' }),
    value: 'receiveFinishTime',
  },

  {
    label: $i18n.get({ id: 'ShelvingCompletionTime.four_px', dm: '上架完成时间' }),
    value: 'putawayFinishTime',
  },

  {
    label: $i18n.get({ id: 'TargetShelvingTime.four_px', dm: '目标上架时间' }),
    value: 'expectPutawayTime',
  },
];

/**
 * 退件订单状态类别
 */
const BOUNCE_ORDER_STATUS = [
  {
    label: $i18n.get({ id: 'PendingReceipt.four_px', dm: '待收货' }),
    value: 'UNRECEIVED',
  },

  {
    label: $i18n.get({ id: 'Receiving.four_px', dm: '收货中' }),
    value: 'RECEIVEING',
  },

  {
    label: $i18n.get({ id: 'Received.four_px', dm: '已收货' }),
    value: 'RECEIVED',
  },

  {
    label: $i18n.get({ id: 'Shelving.four_px', dm: '上架中' }),
    value: 'PUTAWAYING',
  },

  {
    label: $i18n.get({ id: 'Shelved.four_px', dm: '已上架' }),
    value: 'PUTAWAYED',
  },
];

/**
 * 退件订单类型
 */
const BOUNCE_ORDER_TYPE = [
  {
    label: $i18n.get({ id: 'Fb4ServiceProviderReturn.four_px', dm: 'FB4服务商退件' }),
    value: 'UR',
  },

  {
    label: $i18n.get({ id: 'Fb4BuyerReturn.four_px', dm: 'FB4买家退件' }),
    value: 'BR',
  },

  {
    label: $i18n.get({ id: 'GrsReturned.four_px', dm: 'GRS退件' }),
    value: 'GRS',
  },
];

const BOUNCE_ORDER_DETAIL_TAB = [
  {
    label: $i18n.get({ id: 'InboundDetails.four_px', dm: '入库明细' }),
    value: 'InboundDetail',
  },

  {
    label: $i18n.get({ id: 'JobLogs.four_px', dm: '作业日志' }),
    value: 'rtaskLog',
  },
];

const IN_ABNORMAL_CAUSE = [
  {
    label: $i18n.get({ id: 'Understaffed.four_px', dm: '人手不足' }),
    value: 'WARE_1',
  },

  {
    label: $i18n.get({ id: 'WarehouseExplosionUnableToHandle.four_px', dm: '仓库爆仓，无法处理' }),
    value: 'WARE_2',
  },

  {
    label: $i18n.get({ id: 'Error.four_px', dm: '操作失误' }),
    value: 'WARE_3',
  },

  {
    label: $i18n.get({ id: 'TheDeliveryBarcodeBoxInformationIs_1025995139.four_px', dm: '到货条码箱唛信息不规范' }),
    value: 'CUST_1',
  },

  {
    label: $i18n.get({ id: 'TheArrivalIsNotStandardizedAnd_2304780415.four_px', dm: '到货不规范，清点耗时' }),
    value: 'CUST_2',
  },

  {
    label: $i18n.get({ id: 'ArrivalDifference.four_px', dm: '到货差异' }),
    value: 'CUST_3',
  },

  {
    label: $i18n.get({ id: 'DeliveredInBatches.four_px', dm: '分批到货' }),
    value: 'CUST_4',
  },

  {
    label: $i18n.get({ id: 'ReceiptExceptionNotReceivedActually.four_px', dm: '签收异常-实际未收到' }),
    value: 'CUST_5',
  },

  {
    label: $i18n.get({ id: 'TheWarehouseArrivedLateAndThe_1331536483.four_px', dm: '到仓时间较晚，仓库来不及操作' }),
    value: 'CUST_6',
  },

  {
    label: $i18n.get({ id: 'SystemException.four_px', dm: '系统异常' }),
    value: 'SYS_1',
  },

  {
    label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
    value: 'OTHER_1',
  },
];

/**
 * 入库打印箱唛类别
 */
const PRINT_BOX_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'a',
  },

  {
    label: $i18n.get({ id: 'Custom.four_px', dm: '自定义' }),
    value: 'd',
  },
];

/**
 * 增值订单
 */

/**
 * 详情
 */

// VAS单号
const VAS_ORDER = [
  {
    label: $i18n.get({ id: 'EntrustmentNumber.four_px', dm: '委托单号' }),
    value: 'consignmentNos',
  },

  {
    label: $i18n.get({ id: 'CustomerOrderNo.four_px', dm: '客户订单号' }),
    value: 'refNoList',
  },

  {
    label: $i18n.get({ id: 'WarehouseReceiptReferenceNumber.four_px', dm: '入库单参考号' }),
    value: 'inboundOrderList',
  },

  {
    label: $i18n.get({ id: 'OutboundOrderNo.four_px', dm: '出库单号' }),
    value: 'outboundNos',
  },
  {
    label: $i18n.get({ id: 'WarehouseReceiptNo.four_px', dm: '入库单号' }),
    value: 'inboundNos',
  },
];

// 增值服务操作段 服务分段
const VAS_OPERATE_PERIOD = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'ValueAddedSegmentsInTheDatabase.four_px', dm: '库内增值段' }),
    value: 'WH',
  },

  {
    label: $i18n.get({ id: 'OutboundValueAddedSegment.four_px', dm: '出库增值段' }),
    value: 'OB',
  },

  {
    label: $i18n.get({ id: 'ValueAddedStorageSegment.four_px', dm: '入库增值段' }),
    value: 'IB',
  },

  {
    label: $i18n.get({ id: 'SpecialValueAddedSegment.four_px', dm: '特殊增值段' }),
    value: 'SP',
  },

  {
    label: $i18n.get({ id: 'ReturnValueAddedSegment.four_px', dm: '退件增值段' }),
    value: 'RM',
  },
];

// 增值服务委托单状态
const VAS_ENTRUST_PERIOD = [
  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },

  {
    label: $i18n.get({ id: 'YSC.Deleted.four_px', dm: '已删除' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'Draft.four_px', dm: '草稿' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'Processing.four_px', dm: '处理中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'ToBeVerified.four_px', dm: '待核实' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },
];

// 增值服务任务单状态
const VAS_TASK_PERIOD_TAB = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'Processing.four_px', dm: '处理中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'PendingConfirmation.four_px', dm: '待确认' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Returned.four_px', dm: '已退回' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },

  // {
  //   label: '草稿',
  //   value: 'N',
  // },
];
// 状态
const VAS_TASK_PERIOD = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'Processing.four_px', dm: '处理中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'PendingConfirmation.four_px', dm: '待确认' }),
    value: 'V',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'Returned.four_px', dm: '已退回' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },

  {
    label: $i18n.get({ id: 'YSC.Deleted.four_px', dm: '已删除' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'PickingOutOfStock.four_px', dm: '拣货缺货' }),
    value: 'PO',
  },

  {
    label: $i18n.get({ id: 'AbnormalPicking', dm: '拣货异常' }),
    value: 'PE',
  },

  {
    label: $i18n.get({ id: 'ToBeMatched', dm: '待匹配' }),
    value: 'MP',
  },

  {
    label: $i18n.get({ id: 'ToBePicked', dm: '待拣货' }),
    value: 'PP',
  },

  {
    label: $i18n.get({ id: 'ToBeChanged', dm: '待换标' }),
    value: 'CL',
  },

  {
    label: $i18n.get({ id: 'ToBeShelved.four_px', dm: '待上架' }),
    value: 'PA',
  },

  {
    label: $i18n.get({ id: 'ShelvingCompleted.four_px', dm: '上架完成' }),
    value: 'PF',
  },
];

// 增值服务类型
const VAS_SERVICE_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'ProductRepackaging.four_px', dm: '商品重新包装' }),
    value: 'RP',
  },

  {
    label: $i18n.get({ id: 'Photo.four_px', dm: '拍照' }),
    value: 'PG',
  },

  {
    label: $i18n.get({ id: 'TagProcessing.four_px', dm: '标签处理' }),
    value: 'HL',
  },

  {
    label: $i18n.get({ id: 'QDKC.InventoryCheck.four_px', dm: '清点库存' }),
    value: 'CS',
  },

  {
    label: $i18n.get({ id: 'ProductVerification.four_px', dm: '商品核实' }),
    value: 'VG',
  },

  {
    label: $i18n.get({ id: 'VerifyTheVolumeWeight.four_px', dm: '核实材积重量' }),
    value: 'VVW',
  },

  {
    label: $i18n.get({ id: 'UnpackingAndShelving.four_px', dm: '拆箱上架' }),
    value: 'UP',
  },

  {
    label: $i18n.get({ id: 'ClosedBoxShelving.four_px', dm: '合箱上架' }),
    value: 'BP',
  },

  {
    label: $i18n.get({ id: 'SpecialValueAdded.four_px', dm: '特殊增值' }),
    value: 'SS',
  },

  {
    label: $i18n.get({ id: 'MfCombinedValueAddedServices.four_px', dm: 'MF组合增值服务' }),
    value: 'MFC',
  },

  {
    label: $i18n.get({ id: 'APairAHuanBiao.four_px', dm: '一对一换标' }),
    value: 'OTOC',
  },

  {
    label: $i18n.get({ id: 'TransferOfGoodsRights.four_px', dm: '货权转移' }),
    value: 'TOC',
  },
];

// 增值服务操作项
const VAS_SERVICE_OPERATE = [
  {
    label: $i18n.get({ id: 'APairAHuanBiao.four_px', dm: '一对一换标' }),
    value: 'MFPSL',
  },
  {
    label: $i18n.get({ id: 'UnpackingPhotos.four_px', dm: '拆外包装拍照' }),
    value: 'MFUP',
  },

  {
    label: $i18n.get({ id: 'Photo.four_px', dm: '拍照' }),
    value: 'MFP',
  },

  {
    label: $i18n.get({ id: 'Destruction.four_px', dm: '销毁' }),
    value: 'MFDS',
  },

  {
    label: $i18n.get({ id: 'TuiCang.four_px', dm: '退仓' }),
    value: 'MFRW',
  },

  {
    label: $i18n.get({ id: 'Repackaging.four_px', dm: '重新包装' }),
    value: 'MFRP',
  },

  {
    label: $i18n.get({ id: 'PlasticPackaging.four_px', dm: '加塑料包装' }),
    value: 'APT',
  },

  {
    label: $i18n.get({ id: 'OuterPackagePhoto.four_px', dm: '外包装拍照' }),
    value: 'OPP',
  },

  {
    label: $i18n.get({ id: 'UnpackAndTakePhotos.four_px', dm: '拆包装拍照' }),
    value: 'UPP',
  },

  {
    label: $i18n.get({ id: 'LabelSku.four_px', dm: '贴sku标签' }),
    value: 'PSL',
  },

  {
    label: $i18n.get({ id: 'CoverTheSkuLabel.four_px', dm: '覆盖贴sku标签' }),
    value: 'PSC',
  },

  {
    label: $i18n.get({ id: 'DoNotOverwriteTheSkuLabel.four_px', dm: '不覆盖贴sku标签' }),
    value: 'PSU',
  },

  {
    label: $i18n.get({ id: 'LabelOverweight.four_px', dm: '贴超重标签' }),
    value: 'POL',
  },

  {
    label: $i18n.get({ id: 'PastingBox.four_px', dm: '贴箱唛' }),
    value: 'PBM',
  },

  {
    label: $i18n.get({ id: 'StickerClasp.four_px', dm: '贴托唛' }),
    value: 'PPM',
  },

  {
    label: $i18n.get({ id: 'VeneerSheet.four_px', dm: '贴面单' }),
    value: 'PW',
  },

  {
    label: $i18n.get({ id: 'PastePackingList.four_px', dm: '贴装箱单' }),
    value: 'PPL',
  },

  {
    label: $i18n.get({ id: 'QDKC.InventoryCheck.four_px', dm: '清点库存' }),
    value: 'CS',
  },

  {
    label: $i18n.get({ id: 'VerifyColorAccessories.four_px', dm: '核实颜色配件' }),
    value: 'VCP',
  },

  {
    label: $i18n.get({ id: 'VerifyTheVolumeWeight.four_px', dm: '核实材积重量' }),
    value: 'VVW',
  },

  {
    label: $i18n.get({ id: 'ProductContentIdentification.four_px', dm: '商品内物辨识' }),
    value: 'GII',
  },

  {
    label: $i18n.get({ id: 'ProductAppearanceIdentification.four_px', dm: '商品外观辨识' }),
    value: 'GOI',
  },

  {
    label: $i18n.get({ id: 'Unboxing.four_px', dm: '拆箱' }),
    value: 'UB',
  },

  {
    label: $i18n.get({ id: 'ClosedBox.four_px', dm: '合箱' }),
    value: 'BX',
  },

  {
    label: $i18n.get({ id: 'PlusPackaging.four_px', dm: '加包装' }),
    value: 'AP',
  },

  {
    label: $i18n.get({ id: 'SpecialOperations.four_px', dm: '特殊操作' }),
    value: 'SO',
  },

  {
    label: $i18n.get({ id: 'LabelEuropeanSecurity.four_px', dm: '贴欧规安全标签' }),
    value: 'PEL',
  },
  {
    label: $i18n.get({ id: 'EFLabelEuropeanSecurity.four_px', dm: 'MF贴欧规安全标签' }),
    value: 'MFPEL',
  },
];

const VAS_ORDER_TYPE = [
  {
    label: $i18n.get({ id: 'WarehouseValueAddService.four_px', dm: '库内增值服务' }),
    value: 'IN',
  },

  {
    label: $i18n.get({ id: 'InboundValueAddService.four_px', dm: '入库增值服务' }),
    value: 'NA',
  },

  {
    label: $i18n.get({ id: 'InsectionValueAddService.four_px', dm: '查验增值服务' }),
    value: 'IE',
  },
];

// 库存质量
const VAS_STOCK_QUALITY = [
  {
    label: $i18n.get({ id: 'Good.four_px', dm: '良好' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'YC.Exception.four_px', dm: '异常' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'TJ.Return.four_px', dm: '退件' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Damaged.four_px', dm: '破损' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'Contraband.four_px', dm: '违禁品' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'GetWet.four_px', dm: '淋湿' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'Mildew.four_px', dm: '霉变' }),
    value: 'M',
  },
];

// 可修改库存质量
const VAS_BEMODIFIED_STOCK_QUALITY = [
  {
    label: $i18n.get({ id: 'Good.four_px', dm: '良好' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'YC.Exception.four_px', dm: '异常' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'Damaged.four_px', dm: '破损' }),
    value: 'B',
  },
];

const VAS_BEMODIFIED_STOCK_QUALITY_E = [
  {
    label: $i18n.get({ id: 'Good.four_px', dm: '良好' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'YC.Exception.four_px', dm: '异常' }),
    value: 'E',
  },
];

const VAS_BEMODIFIED_STOCK_QUALITY_B = [
  {
    label: $i18n.get({ id: 'Good.four_px', dm: '良好' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'Damaged.four_px', dm: '破损' }),
    value: 'B',
  },
];

// 处理类型
const VAS_DEAL_TYPE = [
  {
    label: $i18n.get({ id: 'PlasticPackaging.four_px', dm: '加塑料包装' }),
    value: 'APT',
  },

  {
    label: $i18n.get({ id: 'OuterPackagePhoto.four_px', dm: '外包装拍照' }),
    value: 'OPP',
  },

  {
    label: $i18n.get({ id: 'UnpackAndTakePhotos.four_px', dm: '拆包装拍照' }),
    value: 'UPP',
  },

  {
    label: $i18n.get({ id: 'LabelSku.four_px', dm: '贴sku标签' }),
    value: 'PSL',
  },

  {
    label: $i18n.get({ id: 'CoverTheSkuLabel.four_px', dm: '覆盖贴sku标签' }),
    value: 'PSC',
  },

  {
    label: $i18n.get({ id: 'DoNotOverwriteTheSkuLabel.four_px', dm: '不覆盖贴sku标签' }),
    value: 'PSU',
  },

  {
    label: $i18n.get({ id: 'LabelOverweight.four_px', dm: '贴超重标签' }),
    value: 'POL',
  },

  {
    label: $i18n.get({ id: 'PastingBox.four_px', dm: '贴箱唛' }),
    value: 'PBM',
  },

  {
    label: $i18n.get({ id: 'StickerClasp.four_px', dm: '贴托唛' }),
    value: 'PPM',
  },

  {
    label: $i18n.get({ id: 'VeneerSheet.four_px', dm: '贴面单' }),
    value: 'PW',
  },

  {
    label: $i18n.get({ id: 'PastePackingList.four_px', dm: '贴装箱单' }),
    value: 'PPL',
  },

  {
    label: $i18n.get({ id: 'LabelEuropeanSecurity.four_px', dm: '贴欧规安全标签' }),
    value: 'PEL',
  },

  {
    label: $i18n.get({ id: 'LabelFbaProducts.four_px', dm: '贴FBA商品标签' }),
    value: 'PFL',
  },

  {
    label: $i18n.get({ id: 'QDKC.InventoryCheck.four_px', dm: '清点库存' }),
    value: 'CS',
  },

  {
    label: $i18n.get({ id: 'VerifyColorAccessories.four_px', dm: '核实颜色配件' }),
    value: 'VCP',
  },

  {
    label: $i18n.get({ id: 'VerifyTheVolumeWeight.four_px', dm: '核实材积重量' }),
    value: 'VVW',
  },

  {
    label: $i18n.get({ id: 'ProductContentIdentification.four_px', dm: '商品内物辨识' }),
    value: 'GII',
  },

  {
    label: $i18n.get({ id: 'ProductAppearanceIdentification.four_px', dm: '商品外观辨识' }),
    value: 'GOI',
  },

  {
    label: $i18n.get({ id: 'Unboxing.four_px', dm: '拆箱' }),
    value: 'UB',
  },

  {
    label: $i18n.get({ id: 'ClosedBox.four_px', dm: '合箱' }),
    value: 'BX',
  },

  {
    label: $i18n.get({ id: 'PlusPackaging.four_px', dm: '加包装' }),
    value: 'AP',
  },

  {
    label: $i18n.get({ id: 'APairAHuanBiao.four_px', dm: '一对一换标' }),
    value: 'MFPSL',
  },

  {
    label: $i18n.get({ id: 'Photo.four_px', dm: '拍照' }),
    value: 'MFP',
  },

  {
    label: $i18n.get({ id: 'Destruction.four_px', dm: '销毁' }),
    value: 'MFDS',
  },

  {
    label: $i18n.get({ id: 'Repackaging.four_px', dm: '重新包装' }),
    value: 'MFRP',
  },

  {
    label: $i18n.get({ id: 'SpecialOperations.four_px', dm: '特殊操作' }),
    value: 'SO',
  },

  {
    label: $i18n.get({ id: 'TransferOfGoodsRights.four_px', dm: '货权转移' }),
    value: 'CRT',
  },

  {
    label: $i18n.get({ id: 'APairAHuanBiao.four_px', dm: '一对一换标' }),
    value: 'CSL',
  },

  {
    label: 'DROPSHIP',
    value: 'DROPSHIP',
  },

  {
    label: 'RESELLER',
    value: 'RESELLER',
  },

  {
    label: $i18n.get({ id: 'Destruction.four_px', dm: '销毁' }),
    value: 'DESTRUCTION',
  },

  {
    label: $i18n.get({ id: 'LabelEuropeanSecurity.four_px', dm: '贴欧规安全标签' }),
    value: 'MFPEL',
  },
  {
    label: $i18n.get({ id: 'UnpackTakePhotos.four_px', dm: '拆外包装拍照' }),
    value: 'MFUP',
  },
];

// 标签类型 数量文案
// 贴超重标签 Paste overweight label
//       贴箱唛 Paste box mark
//       贴托唛 Paste pallet mark
//       贴面单 Paste waybill
//       贴装箱单 Paste packing list
//       贴欧规安全标签 Paste Europe label
//       贴FBA商品标签 Paste FBA Product Label
const LABEL_TEXT = [
  {
    label: $i18n.get({ id: 'PasteOverweightLabel.four_px', dm: '贴超重标签总数量' }),
    value: 'POL',
  },

  {
    label: $i18n.get({ id: 'PasteBoxMark.four_px', dm: '贴箱唛总数量' }),
    value: 'PBM',
  },

  {
    label: $i18n.get({ id: 'PastePalletMark.four_px', dm: '贴托唛总数量' }),
    value: 'PPM',
  },

  {
    label: $i18n.get({ id: 'PasteWaybill.four_px', dm: '贴面单总数量' }),
    value: 'PW',
  },

  {
    label: $i18n.get({ id: 'PastePackingList.four_px', dm: '贴装箱单总数量' }),
    value: 'PPL',
  },

  {
    label: $i18n.get({ id: 'PasteEuropeLabel.four_px', dm: '贴欧规安全标签总数量' }),
    value: 'PEL',
  },

  {
    label: $i18n.get({ id: 'PasteFBAProductLabel.four_px', dm: '贴FBA商品标签总数量' }),
    value: 'PFL',
  },

  {
    label: $i18n.get({ id: 'VerifyTheTotalQuantity.four_px', dm: '核实总数量' }),
    value: 'VVW',
  },
];

// 拍照类型
const VAS_PHOTOT_TYPE = [
  {
    label: $i18n.get({ id: 'OuterPackagePhoto.four_px', dm: '外包装拍照' }),
    value: 'OPP',
  },

  {
    label: $i18n.get({ id: 'UnpackAndTakePhotos.four_px', dm: '拆包装拍照' }),
    value: 'UPP',
  },

  {
    label: $i18n.get({ id: 'OthersPleaseUploadTheChart', dm: '其他(请上传列图)' }),
    value: 'OTR',
  },

  {
    label: $i18n.get({ id: 'PatDamageAbnormalPartialDrawing', dm: '拍破损/异常局部图' }),
    value: 'TDP',
  },

  {
    label: $i18n.get({ id: 'TakeTheOverallOuterPackageDrawing_124992438', dm: '拍整体外包装图' }),
    value: 'TOP',
  },

  {
    label: $i18n.get({ id: 'SKUBarcode', dm: '拍SKU条码' }),
    value: 'TSB',
  },

  {
    label: $i18n.get({ id: 'TakeAFamilyPhoto', dm: '拍全家福' }),
    value: 'TFP',
  },

  {
    label: $i18n.get({ id: 'TakeAFrontPhotoOfThe_443618822', dm: '拍产品正面照' }),
    value: 'TVP',
  },
];

// actualSkuStockQuality零售SKU质量类型
const VAS_SKU_STOCK_QUALITY = [
  {
    label: $i18n.get({ id: 'Good.four_px', dm: '良好' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'YC.Exception.four_px', dm: '异常' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'TJ.Return.four_px', dm: '退件' }),
    value: 'R',
  },
];

// 订单来源
const VAS_ORDER_SOUCE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'CainiaoAe.four_px', dm: '菜鸟AE' }),
    value: 'AE3PL',
  },

  {
    label: 'EWTP',
    value: 'AE4PL',
  },

  {
    label: 'AE4PL',
    value: 'AE4PL2',
  },

  {
    label: 'API',
    value: 'API',
  },

  {
    label: $i18n.get({ id: 'CainiaoHeadCourse.four_px', dm: '菜鸟头程' }),
    value: 'FIRSTLEG',
  },

  {
    label: 'GFC',
    value: 'GFC',
  },

  {
    label: 'ICBU',
    value: 'ICBU',
  },

  {
    label: 'MF3PL',
    value: 'MF',
  },

  {
    label: 'EF4PL',
    value: 'MF4PL',
  },

  {
    label: 'OPEN-API',
    value: 'OMS',
  },

  {
    label: $i18n.get({ id: 'CainiaoOverseasWarehouse.four_px', dm: '菜鸟海外仓' }),
    value: 'OVERSEA',
  },

  {
    label: 'DS',
    value: 'PT',
  },

  {
    label: $i18n.get({ id: 'QiMen.four_px', dm: '奇门' }),
    value: 'QIMEN',
  },

  {
    label: $i18n.get({ id: 'SuningGermanyWarehouse.four_px', dm: '苏宁德国仓' }),
    value: 'SUNINGDE',
  },

  {
    label: $i18n.get({ id: 'WebsiteOrder.four_px', dm: '网站下单' }),
    value: 'WEB',
  },
];

// 服务分类
const VAS_SERVICE_KIND = [
  {
    label: $i18n.get({ id: 'OverseasWarehouseValueAddedServices.four_px', dm: '海外仓增值服务' }),
    value: 'OS',
  },
];

// 操作日志 --- 描述
const VAS_OPERATE_LOG = [
  {
    label: $i18n.get({ id: 'AssignPicker.four_px', dm: '分配拣货员' }),
    value: 'CREATED',
  },

  {
    label: $i18n.get({ id: 'Shelves.four_px', dm: '下架' }),
    value: 'PICKED',
  },

  {
    label: $i18n.get({ id: 'UpperShelf.four_px', dm: '上架' }),
    value: 'PUTAWAY',
  },

  {
    label: $i18n.get({ id: 'MakeUp.four_px', dm: '补拣' }),
    value: 'REPICKED',
  },

  {
    label: $i18n.get({ id: 'ClaimOrders.four_px', dm: '认领订单' }),
    value: 'VALUE_TASK_CLAIM',
  },

  {
    label: $i18n.get({ id: 'CompleteTheOrder.four_px', dm: '完成订单' }),
    value: 'VALUE_TASK_COMPLETE',
  },
  {
    label: $i18n.get({ id: 'AssociatedNumber', dm: '关联单号' }),
    value: 'VALUE_ADDED_TASK_INTERRELATE_NO',
  },
  {
    label: $i18n.get({ id: 'Unassociate', dm: '取消关联' }),
    value: 'VALUE_ADDED_TASK_CANCEL_INTERRELATE_NO',
  },
];

//  customerType:客户类型
const ACTUAL_ARRIVAL_METHOD = [
  {
    label: $i18n.get({ id: 'BulkCargoArrivalCabinetOrTruck_1202027824', dm: '散货到货(柜或者卡车)' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'CallTheGoodsCabinetOrTruck_265989678', dm: '打托到货(柜或者卡车)' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'ExpressParcelArrival', dm: '快递包裹到货' }),
    value: 'E',
  },
];

//  customerType:客户类型
const CUSTOMER_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: 'VIP',
    value: 'VIP',
  },

  {
    label: $i18n.get({ id: 'Standard', dm: '标准' }),
    value: 'Standard',
  },
];

/**
 * 是否需要换标
 */
const VAS_CHANGE_LABEL_FLAG = [
  {
    label: $i18n.get({ id: '31255238468046848.CNTM', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Unchanged', dm: '未换标' }),
    value: 'UEX',
  },

  {
    label: $i18n.get({ id: 'ChangedStandard', dm: '已换标' }),
    value: 'AEX',
  },

  {
    label: $i18n.get({ id: 'NoNeedToChangeTheStandard_142682142', dm: '无需换标' }),
    value: 'NEX',
  },
];

// 详情综合Tab
const GENERAL_TAB = [
  {
    label: $i18n.get({ id: 'OperationLogs.four_px', dm: '操作日志' }),
    value: 'log',
  },

  {
    label: $i18n.get({ id: 'OperationResult.four_px', dm: '操作结果' }),
    value: 'res',
  },
];

// 打印托盘列表 输入下拉
const PALLET_LISTTYPE = [
  {
    label: $i18n.get({ id: 'ToldOrderNumber', dm: '打印单号' }),
    value: 'jobNo',
  },
  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNo',
  },
  {
    label: $i18n.get({ id: 'LogisticsNumber.four_px', dm: '物流单号' }),
    value: 'shippingNo',
  },
  {
    label: $i18n.get({ id: '31255237876649984.CNTM', dm: '包裹号' }),
    value: 'parcelNo',
  },
];

const PALLET_LISTSTATUS = [
  {
    label: $i18n.get({ id: 'TERM.Created_VPs4O', dm: '已创建' }),
    value: 'CREATED',
  },
  {
    label: $i18n.get({ id: 'Loading.zg7pk', dm: '装车中' }),
    value: 'LOADING',
  },
  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'COMPLETED',
  },
  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'CANCELLED',
  },
];

// 紧急程度
const URGENT_LEVEL = [
  {
    label: $i18n.get({ id: 'Emergency', dm: '紧急' }),
    value: 'CRITICAL',
  },
  {
    label: $i18n.get({ id: 'Normal.four_px', dm: '正常' }),
    value: 'NORMAL',
  },
  {
    label: $i18n.get({ id: 'Extension', dm: '延期' }),
    value: 'DELAYED',
  },
];

// 增值服务 -- 服务名
const VAS_SERVICE_API = '/giws-solution';

const PORTAL_SERVICE_API = 'portal';

export {
  ORDER_TIME,
  ORDER_MODULE_STATUS,
  ABNORMAL_CAUSE,
  SLA_STATUS,
  SLA_TYPE,
  ARRAIVAL_TYPE,
  CARRIER_TYPE,
  CAUSE_BY,
  CAUSE_LIST,
  IS_RECEIVE,
  IS_UNLOAD,
  IS_NEW_ITEM,
  IN_ORDER_CHECKBOX_TYPE,
  INBOUND_DETAIL_TABLE,
  OUTBOUND_DETAIL_TABLE,
  BOUNCE_DETAIL_TABLE,
  OPERATE_TYPE,
  OPERATE_CONTENT,
  IN_OPERATE_CON,
  IN_OPERATE_TYPE,
  BOUNCE_ORDER,
  BOUNCE_ORDER_STATUS,
  BOUNCE_ORDER_TYPE,
  BOUNCE_ORDER_TIME,
  BOUNCE_ORDER_DETAIL_TAB,
  IN_ABNORMAL_CAUSE,
  PRINT_BOX_TYPE,
  IS_CLOSE_BATCH,
  VAS_ORDER,
  VAS_OPERATE_PERIOD,
  VAS_ENTRUST_PERIOD,
  VAS_TASK_PERIOD,
  VAS_SERVICE_TYPE,
  VAS_SERVICE_OPERATE,
  VAS_ORDER_TYPE,
  VAS_TASK_PERIOD_TAB,
  VAS_SKU_STOCK_QUALITY,
  VAS_ORDER_SOUCE,
  VAS_STOCK_QUALITY,
  VAS_BEMODIFIED_STOCK_QUALITY,
  VAS_BEMODIFIED_STOCK_QUALITY_E,
  VAS_BEMODIFIED_STOCK_QUALITY_B,
  VAS_DEAL_TYPE,
  LABEL_TEXT,
  VAS_PHOTOT_TYPE,
  VAS_SERVICE_KIND,
  VAS_OPERATE_LOG,
  VAS_CHANGE_LABEL_FLAG,
  GENERAL_TAB,
  VAS_SERVICE_API,
  PORTAL_SERVICE_API,
  BOUNCE_OPERATE_TYPE,
  BOUNCE_OPERATE_CONTENT,
  CUSTOMER_TYPE,
  ACTUAL_ARRIVAL_METHOD,
  PALLET_LISTTYPE,
  PALLET_LISTSTATUS,
  URGENT_LEVEL,
};
